import { Link } from "react-router-dom";
import { FooterLogo } from "../../assets/global/Icons";
import "./NotFound.scss";

function NotFound() {
  return (
    <div className="wrapper center">
      <FooterLogo className="not-found__mark" />
      <div className="not-found__code" aria-hidden="true">
        404
      </div>
      <h1>This page isn't on the menu</h1>
      <hr className="divider--decorative" />
      <p>
        The page you requested may have been moved, or the link may be outdated.
        Head home, or browse the dessert menu to find something sweet.
      </p>
      <div className="flex-container not-found__actions margin-top-md">
        <Link to="/">
          <button className="btn" type="button">
            Back to home
          </button>
        </Link>
        <Link to="/menu">
          <button className="btn" type="button">
            Browse the menu
          </button>
        </Link>
      </div>
    </div>
  );
}

export default NotFound;
